export default __webpack_public_path__ + "static/media/mrs-provence.9a59f4f9.webp";